import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import StyledText from '#components/a/StyledText'
import NachweisIcon from '#components/svg/icons/NavAusbildungsnachweise'
import {routeHelper} from '#config/routeKeys'

export default function NachweisAblehnenBenachrichtigung(props){
  const onClickNotification = () => {
    const {onNotificationClick, nachweisId} = props
    onNotificationClick(routeHelper.ausbildungsnachweisDetail(nachweisId))
  }

    const text = i18n.t('notification_text_nachweis_ablehnen', [props.nachweisNummer])
    return (
      <div
        role="button"
        tabIndex={0}
        className="notification"
        onClick={onClickNotification}
        onKeyPress={onClickNotification}
      >
        <div className="notification__icon nachweis_notification">
          <NachweisIcon />
        </div>
        <StyledText text={text} modifier="notification" />
      </div>
    )
}

NachweisAblehnenBenachrichtigung.propTypes = {
  nachweisId: PropTypes.string,
  nachweisNummer: PropTypes.number,
  onNotificationClick: PropTypes.func.isRequired,
}
